export default __webpack_public_path__ + "static/media/2 - Современное освещение в парках.6b2243fe.jpg";